import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RealizationSummaryTimeline from 'workspace/RealizationSummaryTimeline'
import WorkspaceLocationsEmpty from 'workspace/WorkspaceLocationsEmpty'

const RealizationSummaryTimelines = ({ ids }) => (
  <div>
    {ids.map(id => <RealizationSummaryTimeline key={id} id={id} />)}
    {ids.length === 0 && <WorkspaceLocationsEmpty />}
  </div>
)

RealizationSummaryTimelines.defaultProps = {
  ids: []
}

RealizationSummaryTimelines.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number)
}

const mapStateToProps = (state) => ({
  ids: state.locations.selectedIds
})

export default connect(mapStateToProps)(RealizationSummaryTimelines)
